
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { User } from '../models/auth.models';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

export interface Customer {
  _id: string;
  name: string;
  email: string;
  userId: string;
  plan: string;
  status: string;
  documents: number;
  users: number;
  mrr: number;
  planNote: string;
  paymentMode: string;
  apiCalls: number;
  phone?: string;
  company?: string;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  apiUrl = environment.apiUrl;


  constructor(private http: HttpClient) { }


  getAll() {
    return this.http.get<User[]>(`/api/login`);
  }

  register(user: User) {
    return this.http.post(`/users/register`, user);
  }

  dashboard() {
    return this.http.get(`${this.apiUrl}/admin/analytics/dashboard`);
  }

  getAnalyticsRevenue() {
    return this.http.get(`${this.apiUrl}/admin/analytics/revenue`);
  }

  getCustomers(paramsObj: any): Observable<Customer[]> {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get<Customer[]>(`${this.apiUrl}/admin/customers`, { params });
  }

  getEstampCustomers(paramsObj: any): Observable<Customer[]> {
    let params = new HttpParams();

    if (paramsObj) {
      Object.keys(paramsObj).forEach(key => {
        const value = paramsObj[key];
        if (value !== null && value !== undefined && value !== '') {
          params = params.set(key, value);
        }
      });
    }
    return this.http.get<any[]>(`${this.apiUrl}/bulk-estamp/clients`, { params });
  }

  updateCustomer(customerId: string, payload: Partial<Customer>) {
    return this.http.patch<Customer>(`${this.apiUrl}/admin/customers/${customerId}`, payload);
  }

  deactivateCustomer(customerId: string, payload: Partial<Customer>) {
    return this.http.patch<Customer>(`${this.apiUrl}/admin/customers/${customerId}/customerStatus`, payload);
  }

  getMonthlyDocStatus(date: any) {
    return this.http.get(`${this.apiUrl}/admin/analytics/documents/${date}`)
  }

  getCustomerDetail(customerId: string) {
    return this.http.get<Customer>(`${this.apiUrl}/admin/customers/${customerId}`)
  }

  getClientConfig(clientEmail: string) {
    return this.http.get(`${this.apiUrl}/bulk-estamp/admin/client/${clientEmail}/config`);
  }

  updateClientConfig(clientEmail: string, payload: any) {
    return this.http.patch(`${this.apiUrl}/bulk-estamp/admin/client/${clientEmail}/config`, payload);
  }

}
